var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user)?_c('div',{staticClass:"menu user-menu"},[_vm._v("\n  Welcome,"),_c('br'),_c('strong',[_c('em',[_vm._v(_vm._s(_vm.displayName))])]),_vm._v("!\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }